import { EmptyState } from '@/components/ds/EmptyState'
import { PageHeader } from '@/components/ds/PageHeader'
import { TiktokAnalyticsPage } from '@/features/platforms/tiktok/analytics/TiktokAnalyticsPage'
import { YoutubeAnalyticsPage } from '@/features/platforms/youtube/analytics/YoutubeAnalyticsPage'
import { useActiveChannelFromUrl } from '@/hooks/useActiveChannel'
import styles from './AnalyticsPage.module.scss'

/**
 * Analytics dashboard route entry — dispatches to the platform-specific
 * page based on ``active.platform``. Mirrors :class:`UploadModal` and
 * :class:`PlatformAuthSection` so adding a third platform later means
 * dropping a folder under ``features/platforms/<plat>/analytics/`` and
 * adding one branch here.
 *
 * The empty + loading states (no channel chosen, channels still
 * loading) live here so each platform page doesn't re-implement them.
 */
export function AnalyticsPage() {
  const { active, channels, isLoading: channelsLoading } = useActiveChannelFromUrl()

  if (channelsLoading) {
    return (
      <div className={styles.page}>
        <PageHeader eyebrow="Visão do canal" title="Analytics" />
        <p>Carregando...</p>
      </div>
    )
  }
  if (channels.length === 0 || !active) {
    return (
      <div className={styles.page}>
        <PageHeader eyebrow="Visão do canal" title="Analytics" />
        <EmptyState title="Sem canal selecionado" description="Escolha um canal no sidebar." />
      </div>
    )
  }

  if (active.platform === 'tiktok') {
    return <TiktokAnalyticsPage channel={active} />
  }
  return <YoutubeAnalyticsPage channel={active} />
}
